import { useTranslation } from 'react-i18n-lite'

import { Text } from '@yes.technology/react-toolkit'

import { Container, Content, Image } from './styles'

const IMAGE_URL =
  'https://s3.amazonaws.com/yes.network/static-files/not-a-draft.png'

function GenericErrorPage() {
  const { t } = useTranslation()

  return (
    <Container>
      <Content>
        <Image src={IMAGE_URL} />
        <Text as='h3' variant='heading-emphasis-01'>
          {t('draft-is-concluded.des')}
        </Text>
      </Content>
    </Container>
  )
}

export default GenericErrorPage
